module.exports = __webpack_public_path__ + "img/zylc.2d0a1058.png";